import React from "react";

export const useSelectValue = (
  initValue = ""
): [string, React.ChangeEventHandler<HTMLSelectElement>] => {
  const [state, setState] = React.useState<string>(initValue);
  const onChangeHandler: React.ChangeEventHandler<HTMLSelectElement> = (e) => {
    setState(e.target.value);
  };

  return [state, onChangeHandler];
};
